import { consumer } from "@spawn/core";
import { IBraggResponseFreegameEvent } from "@spawn/freegames";
import { INetworkState } from "@spawn/networking";
import { CacheKeys, CacheStorage } from "../../utils/cacheStorage";
import { FGInitActionBragg } from "./fgInitActionBragg";

@consumer
export class FGPseudoInitActionBragg extends FGInitActionBragg {
	public execute(): Promise<INetworkState> {
		const response = CacheStorage.get<IBraggResponseFreegameEvent>(CacheKeys.FirstFGResumeResponse);
		if (!response) {
			throw new Error("No cached response found");
		}

		return Promise.resolve(this.parse(response, this.adapter));
	}
}
